import { configureStore } from "@reduxjs/toolkit";
import adminSlice from "./admin/adminSlice";
import noticeSlice from "./notice/noticeSlice";
import settingSlice from "./setting/settingSlice";

const store = configureStore({
  reducer: {
    admin: adminSlice,
    notice: noticeSlice,
    setting: settingSlice,
  },
});
export default store;